var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"pt-5":"","mt-4":"","justify-center":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-img',{attrs:{"src":_vm.src}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('panel',{attrs:{"title":"Page Not Found"}},[_c('v-flex',[_vm._v("\n       Page Not Found.\n       ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec27d09c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = null
// module chunks = 